import { Routes } from '@angular/router';
import { noAuthGuard } from '@app/core/guards/no-auth.guard';
import { hasProfileGuard } from '@app/core/guards/has-profile.guard';

export const routes: Routes = [
  {
    path: 'privacy',
    loadComponent: () =>
      import('@app/features/privacy/privacy.component').then((m) => m.PrivacyComponent),
  },
  {
    path: 'support',
    loadComponent: () =>
      import('@app/features/support/support.component').then((m) => m.SupportComponent),
  },
  {
    path: 'auth',
    children: [
      {
        path: 'ms',
        canActivate: [noAuthGuard],
        loadComponent: () =>
          import('@app/features/ms-auth-redirect/ms-auth-redirect.component').then(
            (m) => m.MsAuthRedirectComponent,
          ),
      },
      {
        path: 'login',
        canActivate: [noAuthGuard],
        loadComponent: () =>
          import('@app/features/login/login.component').then((m) => m.LoginComponent),
      },
      {
        // Pas de noAuthGuard ici : un utilisateur MSAL authentifié mais sans
        // profil applicatif valide (rôle inconnu, API BO Users en erreur...)
        // doit pouvoir rester sur cette page sans être renvoyé vers `/`
        // (ce qui provoquerait une boucle infinie via hasProfileGuard).
        path: 'error',
        loadComponent: () =>
          import('@app/features/auth-error/auth-error.component').then((m) => m.AuthErrorComponent),
      },
    ],
  },
  {
    // Layout post-auth commun (navbar + footer) partagé par tous les profils :
    // Planificateur et Conducteur ont les mêmes maquettes/layout, seules
    // certaines actions/options diffèrent (masquées au sein des composants,
    // cf. `AuthService.isPlanificateur` / `isConducteur`, comme dans
    // `NavbarComponent`). `createRoleGuard` (role.guard.ts) reste disponible
    // pour gater une route spécifique à un profil le jour où le besoin existe.
    path: '',
    loadComponent: () =>
      import('@app/layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        canActivate: [hasProfileGuard],
        loadChildren: () =>
          import('@app/features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
